// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productBrandStyles } from "@flip/Overrides/Components/ProductBrand";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { color } from "@flip/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productBrandStyles.nameText = {
    size: 13,
    weight: fontConfig.weight.semiBold,
    color: "text",
    css: css`
        line-height: 13px;
        margin-bottom: 4px;
    `,
};
//  XNG-Changes:FLIP-507
productBrandStyles.nameLink = {
    css: css`
        ${wrapInContainerStyles};
        ${({ isAuthorized }: any) =>
            !isAuthorized &&
            css`
                &&& {
                    ${TypographyStyle} {
                        color: ${color("text")};
                        &:visited {
                            color: ${color("text")};
                        }
                        &:hover {
                            color: ${color("secondary")};
                        }
                    }
                }
            `}
        ${({ isAuthorized }: any) =>
            isAuthorized &&
            css`
                ${TypographyStyle} {
                    @media print {
                        color: ${color("primary.main")} !important;
                    }
                }
            `}
    `,
    typographyProps: {
        size: "13px",
        weight: 600,
    },
};

// XNG-Changes: FLIP-1047
productBrandStyles.brandNotClickable = {
    size: "13px",
    weight: 600,
    color: "text.link",
    css: css`
        ${wrapInContainerStyles};
        ${({ isAuthorized }: any) =>
            !isAuthorized &&
            css`
                &&& {
                    color: ${color("text")};
                }
            `}
        ${({ isAuthorized }: any) =>
            isAuthorized &&
            css`
                @media print {
                    color: ${color("primary.main")} !important;
                }
            `}
    `,
};
